import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/CourseBySlug'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class CourseBySlugStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "CourseBySlugStore",
			variables: true,
		})
	}
}

export async function load_CourseBySlug(params) {
	await initClient()

	const store = new CourseBySlugStore()

	await store.fetch(params)

	return {
		CourseBySlug: store,
	}
}
